import type { Theme } from './types';

/**
 * KIM LONG — nền tối, vàng kim, đặc số liệu.
 *
 * Đây là giao diện gốc của nền tảng và là mặc định khi tên miền chưa được ánh xạ.
 * Giá trị token trùng khớp `styles/tokens.css` để website đang chạy không đổi hình
 * dạng khi kho giao diện được lắp vào.
 *
 * Tính cách: sòng phẳng, dày đặc, hợp người chơi xem bảng số nhiều giờ mỗi tối.
 */
export const kimLong: Theme = {
  id: 'kim-long',
  brandName: 'KIM LONG',
  tagline: 'Nền tối, vàng kim, đặc số liệu — dành cho người chơi ngồi lâu.',

  scheme: 'dark',
  layout: 'top',
  navStyle: 'underline',
  mark: 'kim-cuong',

  fonts: {
    display: "'Be Vietnam Pro'",
    body: "'Inter'",
    href: 'https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@600;700;800&family=Inter:wght@400;500;600;700&display=swap',
  },

  tokens: {
    'bg-root': '#0b0e14',
    'bg-surface': '#131824',
    'bg-raised': '#1a2130',
    'bg-overlay': '#212a3b',
    'bg-input': '#0f1420',
    'bg-hover': '#232d40',

    brand: '#f0b429',
    'brand-strong': '#ffc94d',
    'brand-dim': '#b8860b',
    'brand-contrast': '#0b0e14',
    accent: '#2f81f7',

    positive: '#2ea043',
    'positive-dim': '#1a5c2a',
    negative: '#e5484d',
    'negative-dim': '#6e2226',
    warning: '#e3a008',
    info: '#2f81f7',
    'odds-up': '#2ea043',
    'odds-down': '#e5484d',

    'text-primary': '#e6edf3',
    'text-secondary': '#9aa7b8',
    'text-muted': '#6b7789',
    'text-disabled': '#4a5568',
    'text-on-brand': '#0b0e14',
    'text-inverse': '#0b0e14',

    border: '#232b3a',
    'border-strong': '#313c50',

    'shadow-sm': '0 1px 2px rgb(0 0 0 / 40%)',
    'shadow-md': '0 4px 12px rgb(0 0 0 / 45%)',
    'shadow-lg': '0 12px 32px rgb(0 0 0 / 55%)',

    'font-display': "'Be Vietnam Pro', 'Segoe UI', system-ui, sans-serif",
    'font-sans': "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",

    'radius-sm': '3px',
    'radius-md': '6px',
    'radius-lg': '10px',
    'radius-xl': '16px',
    /* `--radius-full` la khoa hinh VIEN THUOC (the, nhan, tab), khong phai hinh tron
       tuyet doi — khong cho nao dung no cho anh dai dien hay cham tron. Nen mot thuong
       hieu lay goc vuong lam nhan dien duoc phep vuong hoa ca nhung cho nay; de nguyen
       999px thi nut chinh bo tron lop lop giua mot trang toan goc nhon, nhin ra ngay
       la hai bo quy tac danh nhau.
       Giu vien thuoc. */
    'radius-full': '999px',

    'header-height': '56px',
    'content-max': '1600px',
    'brand-tracking': '0.06em',
    'label-tracking': '0.02em',
    'label-transform': 'none',
  },
};
